module.exports = __webpack_public_path__ + "static/media/bg_narrative_completed.7927d307.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/narratives/bg_narrative_completed.svg
// module id = 1851
// module chunks = 0